import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import { StatementsExpensesFeesRoute } from '~/borrower/routes/statements/StatementsExpensesFeesRoute';
import { StatementsOutstandingLedgerRoute } from '~/borrower/routes/statements/StatementsOutstandingLedgerRoute';

export const StatementsRouter = () => (
  // Paths relative to "/statements/*"
  <Routes>
    <Route
      path="/outstanding-ledger"
      element={<StatementsOutstandingLedgerRoute />}
    />
    <Route path="/expenses-fees" element={<StatementsExpensesFeesRoute />} />
    <Route path="/*" element={<Navigate to="./outstanding-ledger" replace />} />
  </Routes>
);
